import React, { FC, memo } from "react";
import { Avatar } from "antd";
import "./index.less";
import { DownOutlined } from "@ant-design/icons";
interface Props {
  src?: string;
  name?: string;
}
const User: FC<Props> = function (props) {
  return (
    <div className="ec-user-avatar-container">
      {props.src ? <Avatar src={props.src} size={32} /> : null}

      <span className="name">{props.name}</span>

      <DownOutlined className="ml10" style={{ fontSize: 12 }} />
    </div>
  );
};
export default memo(User);
